import { ValdrValidator, ValidatorConfig } from '@app/valdr';
import { hasNoValue } from '@app/valdr/util';
import * as R from 'ramda';

const EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const emailValidator: ValdrValidator = R.curry((config: ValidatorConfig, value: any) =>
  hasNoValue(value) || EMAIL_REGEXP.test(value)
);
